import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSS: CultureInfo = {
  name: 'en-SS',
  displayName: 'English (South Sudan)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SS',
  parent: CultureInfoEn
};
